import type { HtmlTagDescriptor } from 'vite';

export const ONETRUST_SDK_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

export const isOneTrustConfigured = (scriptId: string | undefined): boolean =>
  Boolean(scriptId?.trim());

export const oneTrustHeadTags = (scriptId: string | undefined): HtmlTagDescriptor[] => {
  if (!isOneTrustConfigured(scriptId)) {
    return [];
  }
  const id = scriptId?.trim() as string;
  return [
    {
      tag: 'script',
      attrs: { type: 'text/javascript' },
      children: 'function OptanonWrapper() {}',
      injectTo: 'head-prepend',
    },
    {
      tag: 'script',
      attrs: {
        src: ONETRUST_SDK_URL,
        type: 'text/javascript',
        charset: 'UTF-8',
        'data-domain-script': id,
      },
      injectTo: 'head-prepend',
    },
  ];
};
